module.exports = __webpack_public_path__ + "img/180.a61828db.jpg";